module.exports = __webpack_public_path__ + "img/RBS_retailers.779f9855.png";